import * as React from 'react';

import { navigateTop } from '../routing/router-utils';
import QuantityWarning from '../checkout/QuantityWarning';
import PropTypes from 'prop-types';

import styles from './ReOrder.module.css';

const ReOrderHeader = ({
  dispensaryId,
  dispensaryName,
  image_urls,
  flowerGrams=0  /* will trigger warning if too high */
}) => {
  return (
    dispensaryId
    ? <div className={styles.dispensaryWrap}>
      <div className={styles.dispensaryInfo}>
        <div className={styles.logo}>
          <img alt={dispensaryName} className={styles.logoImage} height="85" src={image_urls?.secondary} />
        </div>
        <div onClick={() => navigateTop(`/dispensary/${dispensaryId}`)} className={styles.dispensaryName}>
          {dispensaryName}
        </div>
      </div>  
      <QuantityWarning gramsInCart={flowerGrams} />
    </div>
    : null
  )
}

ReOrderHeader.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  image_urls: PropTypes.object.isRequired,
  flowerGrams: PropTypes.number.isRequired
}            

export default ReOrderHeader;